(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchor-nav"] && !Shopify.designMode) return;
  try {
    
  // Ankarnavigering: mjuk scroll med hänsyn till headern + markerar den sektion
  // man befinner sig i. Utan JS fungerar chipsen ändå som vanliga #-länkar.
  // <anchor-nav> är ett custom element: det kopplas in på nytt när temaeditorn
  // renderar om sektionen, och alla lyssnare tas bort i disconnectedCallback.
  (() => {
    if (customElements.get('anchor-nav')) return;

    class AnchorNav extends HTMLElement {
      #abort = null;
      #links = [];
      #baseStyle = '';
      #activeStyle = '';
      #stickyWrapper = null;
      #header = null;
      #ticking = false;
      #following = false;
      #followUntil = 0;
      #current = null;
      #lockUntil = 0;

      connectedCallback() {
        const nav = this.querySelector('[data-anchor-nav]');
        if (!nav) return;
        this.#links = Array.from(nav.querySelectorAll('[data-anchor-target]'));
        if (!this.#links.length) return;

        this.#baseStyle = nav.dataset.style || '';
        this.#activeStyle = nav.dataset.styleActive || '';

        const stickyInner = this.closest('.anchor-nav--sticky');
        this.#stickyWrapper = stickyInner ? stickyInner.closest('[id^="shopify-section-"]') || stickyInner : null;
        this.#header = AnchorNav.#findHeader();

        this.#abort = new AbortController();
        const { signal } = this.#abort;

        for (const link of this.#links) {
          link.addEventListener('click', (event) => this.#onClick(event, link), { signal });
          AnchorNav.#ensureAnchor(link.dataset.anchorTarget);
        }

        window.addEventListener('scroll', this.#onScroll, { passive: true, signal });
        window.addEventListener('scrollend', this.#onScrollEnd, { passive: true, signal });
        window.addEventListener('resize', this.#syncStickyTop, { passive: true, signal });

        // Headern glider in/ut på ~0,5 s. Följ med under hela animationen, annars
        // hoppar raden på plats först när animationen är klar.
        if (this.#header) {
          for (const type of ['transitionstart', 'transitionrun', 'transitionend']) {
            this.#header.addEventListener(type, this.#onHeaderTransition, { signal });
          }
        }

        this.#syncStickyTop();
        this.#updateActive();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#abort = null;
        this.#following = false;
        if (this.#stickyWrapper) document.documentElement.style.removeProperty('--anchor-nav-height');
      }

      static #findHeader() {
        return (
          document.querySelector('header[is="sticky-header"]') ||
          document.querySelector('.header-section header') ||
          document.querySelector('.header-section')
        );
      }

      static #sectionFor(name) {
        return (
          document.getElementById(name) ||
          document.getElementById(`shopify-section-${name}`) ||
          document.querySelector(`[id$="__${CSS.escape(name)}"]`)
        );
      }

      // Osynligt ankare först i målsektionen – ger vanligt #-beteende.
      static #ensureAnchor(name) {
        if (!name) return null;
        const existing = document.getElementById(name);
        if (existing) return existing;
        const section = AnchorNav.#sectionFor(name);
        if (!section) return null;
        const anchor = document.createElement('span');
        anchor.id = name;
        anchor.className = 'anchor-nav__target';
        anchor.setAttribute('aria-hidden', 'true');
        section.insertBefore(anchor, section.firstChild);
        return anchor;
      }

      // Temats header glider undan vid nedåtscroll och tillbaka vid uppåtscroll.
      // Raden lägger sig alltid direkt under headerns synliga underkant. Radens höjd
      // går till html:s scroll-padding (se sektionens stil).
      #syncStickyTop = () => {
        if (!this.#stickyWrapper) return 0;
        let offset = 0;
        if (this.#header) {
          const rect = this.#header.getBoundingClientRect();
          offset = Math.max(0, Math.min(rect.bottom, rect.height));
        }
        const height = `${this.#stickyWrapper.offsetHeight}px`;
        const top = `${Math.round(offset)}px`;
        if (this.#stickyWrapper.style.top !== top) this.#stickyWrapper.style.top = top;
        const rootStyle = document.documentElement.style;
        if (rootStyle.getPropertyValue('--anchor-nav-height') !== height) {
          rootStyle.setProperty('--anchor-nav-height', height);
        }
        return offset;
      };

      // Räkna alltid med hela headern vid hopp: temat visar headern igen när man
      // skrollar uppåt, och då hamnade målets överkant annars under den sticky raden.
      #headerOffset() {
        this.#syncStickyTop();
        const offset = this.#header ? Math.round(this.#header.getBoundingClientRect().height) : 0;
        if (this.#stickyWrapper) return offset + this.#stickyWrapper.offsetHeight + 16;
        return offset + 16;
      }

      #targetFor(link) {
        const name = link.dataset.anchorTarget;
        if (!name) return null;
        return document.getElementById(name) || AnchorNav.#sectionFor(name);
      }

      #setActive(link) {
        const changed = link !== this.#current;
        this.#current = link;
        for (const item of this.#links) {
          const isActive = item === link;
          if (this.#activeStyle && this.#baseStyle && this.#activeStyle !== this.#baseStyle) {
            item.classList.toggle(this.#activeStyle, isActive);
            item.classList.toggle(this.#baseStyle, !isActive);
          }
          item.classList.toggle('problem-areas__link--current', isActive);
          if (isActive) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        }
        if (changed) this.#revealLink(link);
      }

      // Raden scrollar i sidled på mobil: skjut in aktuell länk (centrerad) när den
      // byts, så att man alltid ser vilken sektion man är i. Bara i sidled – sidan
      // i sig flyttas inte.
      #revealLink(link) {
        const list = link.closest('.problem-areas__list');
        if (!list || list.scrollWidth <= list.clientWidth) return;
        const listRect = list.getBoundingClientRect();
        const linkRect = link.getBoundingClientRect();
        const margin = 16;
        if (linkRect.left >= listRect.left + margin && linkRect.right <= listRect.right - margin) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollTo({
          left: list.scrollLeft + (linkRect.left - listRect.left) - (listRect.width - linkRect.width) / 2,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      #scrollToTarget(target) {
        const startY = window.scrollY;
        const top = Math.max(target.getBoundingClientRect().top + startY - this.#headerOffset(), 0);
        // "Reducera rörelse": hoppa direkt i stället för att animera
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
        if (reduceMotion) return;
        // Om mjuk scroll inte startar (t.ex. i en flik som inte renderas) – hoppa direkt.
        window.setTimeout(() => {
          if (Math.abs(window.scrollY - startY) < 4 && Math.abs(top - startY) > 8) {
            window.scrollTo(0, top);
          }
        }, 500);
      }

      // preventDefault stoppar webbläsarens vanliga #-hopp – flytta därför fokus till
      // målet, så att Tab och skärmläsare fortsätter där. Det osynliga ankaret är
      // aria-hidden, så sektionen det ligger i får fokus i stället.
      #focusTarget(target) {
        const element = target.classList.contains('anchor-nav__target') ? target.parentElement : target;
        if (!element) return;
        if (!element.hasAttribute('tabindex')) element.setAttribute('tabindex', '-1');
        element.focus({ preventScroll: true });
      }

      #onClick(event, link) {
        const target = this.#targetFor(link);
        if (!target) return;
        event.preventDefault();
        // Scrollspionen vilar under den mjuka scrollen, annars blinkar markeringen
        // förbi sektionerna däremellan (släpps av scrollend eller efter 1,2 s)
        this.#lockUntil = window.performance.now() + 1200;
        this.#scrollToTarget(target);
        this.#setActive(link);
        this.#focusTarget(target);
        // Adressraden visar målet som vid ett vanligt #-hopp
        if (link.hash) history.replaceState(history.state, '', link.hash);
      }

      #onScroll = () => {
        if (this.#ticking) return;
        this.#ticking = true;
        window.requestAnimationFrame(() => this.#updateActive());
      };

      #onScrollEnd = () => {
        if (!this.#lockUntil) return;
        this.#lockUntil = 0;
        this.#updateActive();
      };

      #updateActive() {
        this.#ticking = false;
        if (!this.isConnected) return;
        if (window.performance.now() < this.#lockUntil) return;
        const offset = this.#headerOffset() + 8;
        let current = null;
        for (const link of this.#links) {
          const target = AnchorNav.#sectionFor(link.dataset.anchorTarget);
          if (!target) continue;
          if (target.getBoundingClientRect().top - offset <= 0) current = link;
        }
        if (current) this.#setActive(current);
      }

      #onHeaderTransition = (event) => {
        if (event.propertyName !== 'transform') return;
        this.#followUntil = window.performance.now() + 800;
        if (!this.#following) this.#followHeader();
      };

      #followHeader() {
        if (!this.isConnected) {
          this.#following = false;
          return;
        }
        this.#following = true;
        this.#syncStickyTop();
        if (window.performance.now() < this.#followUntil) {
          window.requestAnimationFrame(() => this.#followHeader());
        } else {
          this.#following = false;
        }
      }
    }

    customElements.define('anchor-nav', AnchorNav);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs-grid"] && !Shopify.designMode) return;
  try {
    
  /*
   * Temats product-tabs.js byter bara klassen .active och skickar händelsen
   * "tabChange" (bubblar, detail.selectedIndex). Här hålls aria-selected i synk så
   * att skärmläsare hör vald flik. Bara för den här sektionen.
   */
  document.addEventListener('tabChange', (event) => {
    const wrapper = event.target;
    if (!(wrapper instanceof HTMLElement) || !wrapper.closest('.collection-tabs-grid')) return;

    const selectedIndex = event.detail?.selectedIndex;
    for (const tab of wrapper.querySelectorAll('[role="tab"]')) {
      tab.setAttribute('aria-selected', String(Number(tab.dataset.index) === selectedIndex));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["problem-nav"] && !Shopify.designMode) return;
  try {
    
  // Centrerar den aktiva chippen i den vågräta scrollen (mobil), utan att röra sidans scroll.
  (function () {
    function centerCurrentChip() {
      document.querySelectorAll('.problem-areas__list').forEach(function (list) {
        var current = list.querySelector('.problem-areas__link--current');
        if (!current || list.scrollWidth <= list.clientWidth) return;
        var item = current.parentElement || current;
        list.scrollLeft = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', centerCurrentChip);
    } else {
      centerCurrentChip();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-timeline"] && !Shopify.designMode) return;
  try {
    
  // Flikarna i varianten "Välj område": klick eller piltangenter byter område.
  // Mönstret följer WAI-ARIA tabs: bara vald flik går att tabba till.
  if (!customElements.get('product-timeline-tabs')) {
    class ProductTimelineTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.addEventListener('click', this.#onClick);
        this.addEventListener('keydown', this.#onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
        this.removeEventListener('keydown', this.#onKeydown);
      }

      /** @param {HTMLElement} tab */
      select(tab) {
        for (const item of this.tabs) {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        }
      }

      /** @param {MouseEvent} event */
      #onClick = (event) => {
        const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
        if (tab && this.contains(tab)) this.select(tab);
      };

      /** @param {KeyboardEvent} event */
      #onKeydown = (event) => {
        const index = this.tabs.indexOf(document.activeElement);
        if (index < 0) return;
        let next = -1;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next < 0) return;
        event.preventDefault();
        this.tabs[next].focus();
        this.select(this.tabs[next]);
      };
    }

    customElements.define('product-timeline-tabs', ProductTimelineTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tidningsutklipp"] && !Shopify.designMode) return;
  try {
    
  class ClippingScroller extends HTMLElement {
    /** @type {AbortController | null} */
    #abortController = null;

    connectedCallback() {
      // Alla lyssnare kopplas till en AbortController så att de tas bort när sektionen
      // renderas om i temaredigeraren (annars ligger t.ex. resize-lyssnaren kvar).
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.track = this.querySelector('[data-clip-track]');
      this.dialog = this.querySelector('[data-clip-dialog]');
      this.dialogImage = this.querySelector('[data-clip-image]');
      this.dialogCaption = this.querySelector('[data-clip-dialog-caption]');
      this.dialogSource = this.querySelector('[data-clip-dialog-source]');
      // Bara utklipp med bild kan öppnas – platshållare i temaredigeraren saknar data-clip-src.
      this.triggers = Array.from(this.querySelectorAll('[data-clip-open][data-clip-src]'));
      this.currentIndex = 0;

      for (const [index, trigger] of this.triggers.entries()) {
        trigger.addEventListener('click', () => this.open(index), { signal });
      }

      const prev = this.querySelector('[data-clip-prev]');
      const next = this.querySelector('[data-clip-next]');
      prev?.addEventListener('click', () => this.scrollByPage(-1), { signal });
      next?.addEventListener('click', () => this.scrollByPage(1), { signal });

      const dialogPrev = this.querySelector('[data-clip-dialog-prev]');
      const dialogNext = this.querySelector('[data-clip-dialog-next]');
      dialogPrev?.addEventListener('click', () => this.step(-1), { signal });
      dialogNext?.addEventListener('click', () => this.step(1), { signal });

      const close = this.querySelector('[data-clip-close]');
      close?.addEventListener('click', () => this.close(), { signal });

      if (this.dialog) {
        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog) this.close();
          },
          { signal }
        );
        this.dialog.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'ArrowRight') this.step(1);
            if (event.key === 'ArrowLeft') this.step(-1);
          },
          { signal }
        );
        this.dialog.addEventListener(
          'close',
          () => {
            document.body.classList.remove('clips-dialog-open');
          },
          { signal }
        );
      }

      if (this.track) {
        this.track.addEventListener('scroll', () => this.updateNav(), { passive: true, signal });
        window.addEventListener('resize', () => this.updateNav(), { signal });
        this.updateNav();
      }
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#abortController = null;
      document.body.classList.remove('clips-dialog-open');
    }

    /** @returns {boolean} */
    #prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    scrollByPage(direction) {
      if (!this.track) return;
      const item = this.track.querySelector('.clips__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
      this.track.scrollBy({
        left: step * direction,
        behavior: this.#prefersReducedMotion() ? 'auto' : 'smooth',
      });
    }

    updateNav() {
      if (!this.track) return;
      const prev = this.querySelector('[data-clip-prev]');
      const next = this.querySelector('[data-clip-next]');
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const overflowing = maxScroll > 2;
      if (prev) prev.hidden = !overflowing || this.track.scrollLeft <= 2;
      if (next) next.hidden = !overflowing || this.track.scrollLeft >= maxScroll - 2;
    }

    open(index) {
      const trigger = this.triggers[index];
      if (!trigger || !this.dialog) return;

      // Utan bild finns inget att visa – öppna aldrig en tom (eller föregående) bild.
      const src = trigger.dataset.clipSrc;
      if (!src) return;

      this.currentIndex = index;

      if (this.dialogImage) {
        this.dialogImage.src = src;
        this.dialogImage.alt = trigger.dataset.clipAlt || '';
        if (trigger.dataset.clipWidth) this.dialogImage.width = trigger.dataset.clipWidth;
        if (trigger.dataset.clipHeight) this.dialogImage.height = trigger.dataset.clipHeight;
      }
      if (this.dialogCaption) this.dialogCaption.textContent = trigger.dataset.clipCaption || '';
      if (this.dialogSource) this.dialogSource.textContent = trigger.dataset.clipSource || '';

      const multiple = this.triggers.length > 1;
      const dialogPrev = this.querySelector('[data-clip-dialog-prev]');
      const dialogNext = this.querySelector('[data-clip-dialog-next]');
      if (dialogPrev) dialogPrev.hidden = !multiple;
      if (dialogNext) dialogNext.hidden = !multiple;

      // step() anropar open() medan dialogen redan är öppen – showModal() på en öppen
      // dialog kastar InvalidStateError i äldre webbläsare.
      if (!this.dialog.open) {
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }
      document.body.classList.add('clips-dialog-open');
    }

    step(direction) {
      if (this.triggers.length < 2) return;
      const total = this.triggers.length;
      const nextIndex = (this.currentIndex + direction + total) % total;
      this.open(nextIndex);
    }

    close() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
      document.body.classList.remove('clips-dialog-open');
    }
  }

  if (!customElements.get('clipping-scroller')) {
    customElements.define('clipping-scroller', ClippingScroller);
  }

  } catch(e) { console.error(e); }
})();
})();
